import React from 'react-dom'
import formatNumber from '../helpers/formatNumber'
import useFetcherDataProvinces from '../hooks/useFetcherDataProvinces'
import Loader from 'react-loader-spinner'
import { Link, useRouteMatch } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import addWatchList from '../store/actions/addWatchList'

const ProvincesPage = () => {
  const [dataProvinces, dataProvincesLoading] = useFetcherDataProvinces()
  const { path } = useRouteMatch()
  const watchLists = useSelector(state => state.watchLists)
  const dispatch = useDispatch()

  const addToWatchList = payload => {
    dispatch(addWatchList(payload))
  }

  if (dataProvincesLoading) {
    return <Loader
    type="ThreeDots"
    color="#00BFFF"
    height={500}
    width={500}
    className="text-center"
    />
  } else {
    return (
      <>
        <div className="container text-center">
          <h1>Jumlah Kasus per Provinsi</h1>
          <div className="row mt-3">
          {dataProvinces.map(dataProvince => (
            <div key={dataProvince.provinsi} className="col-2">
              <div className="card mb-2" style={{maxHeight: '100px'}}>
                <div className="card-title" style={{marginBottom: '-20px'}}>{dataProvince.provinsi}</div>
                <div className="card-body text-primary" style={{fontFamily: 'IBM Plex Mono', fontSize: '15px'}}><div>{formatNumber(formatNumber(dataProvince.kasusPosi))}<br/><div className="text-dark">Terkonfirmasi</div></div></div>
                <div className="card-footer bg-white" style={{padding: 0}}> 
                  <div className="row center">
                    <button onClick={() => addToWatchList(dataProvince)} className="col-6 btn-sm bg-white hvr-bounce-to-top border-0 btnclick" disabled={watchLists.find(el => el.fid === dataProvince.fid)}>
                      <strong>Watch  </strong><i className="fa fa-eye"></i>
                    </button>
                    <Link to={path + '/' + dataProvince.provinsi} className="col-6 btn-sm bg-white hvr-bounce-to-top border-0 btnclick black">
                      <i className="fa fa-info-circle">  Details</i>
                    </Link> 
                  </div>
                </div>
              </div>
            </div>
          ))}
          </div>
        </div>
      </>
    )
  }
}

export default ProvincesPage